const prefix = 'locationSignIn:'

function safeParse(value, fallback) {
  if (!value) {
    return fallback
  }
  try {
    return JSON.parse(value)
  } catch (e) {
    return fallback
  }
}

export function buildLocationSignInKey({ paperItemId, taskId, pointId }) {
  return `${paperItemId}-${taskId}-${pointId}`
}

export function getLocationSignIns(key) {
  return safeParse(localStorage.getItem(prefix + key), [])
}

export function setLocationSignIns(key, signIns) {
  localStorage.setItem(prefix + key, JSON.stringify(signIns || []))
}

export function removeLocationSignIns(key) {
  localStorage.removeItem(prefix + key)
}
